import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { API_URL } from '../api/api.js'; // Adjust this path to match your structure
import axios from 'axios';
import Swal from 'sweetalert2';

const SignInLayer = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
           // Clear all session data on load
     localStorage.clear();
     sessionStorage.clear();
        axios.get(`${API_URL}/sanctum/csrf-cookie`, { withCredentials: true })
            .then(() => console.log("CSRF cookie set"))
            .catch(err => console.error("CSRF token fetch failed:", err));
    }, []);

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Submitting formData:");
        console.log("Submitting formData:", formData);
        try {
            // Ensure CSRF token is properly fetched and awaited
            await axios.get(`${API_URL}/sanctum/csrf-cookie`, { withCredentials: true });

            const response = await axios.post(
                `${API_URL}/login`,
                formData,
                { withCredentials: true }
            );


            const { access_token, token_type, roles, permissions, user } = response.data;

            if (!access_token) {
                throw new Error("Access token not found in response.");
            }

            // Save to localStorage
            localStorage.setItem("token", access_token);
            localStorage.setItem("user", user.name);
            localStorage.setItem("userID", user.id);
            localStorage.setItem("token_type", token_type);
            localStorage.setItem("roles", JSON.stringify(roles));
            localStorage.setItem("userRole", user.role);
            localStorage.setItem("permissions", JSON.stringify(permissions));

            Swal.fire({
                icon: "success",
                title: "Login Successful",
                text: "Welcome back!",
            }).then(() => {
                navigate("/manage-admin-dashboard");
            });
        } catch (error) {
            console.error("Login error:", error.response?.data || error.message);

            // Show sweet alert
            Swal.fire({
                icon: "error",
                title: "Login Failed",
                text: error.response?.data?.message || "Something went wrong. Please try again.",
            });

            // Set validation errors if available
            if (error.response?.data?.errors) {
                setValidationErrors(error.response.data.errors);
            }
        }
    };

    return (
        <section className='auth bg-base d-flex flex-wrap'>
            <div className='auth-left d-lg-block d-none'>
                <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
                    <img src='assets/images/auth/auth-img.png' alt='' />
                </div>
            </div>
            <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
                <div className='max-w-464-px mx-auto w-100'>
                    <div>
                        <Link to='/' className='mb-40 max-w-290-px'>
                            <img src='assets/images/logo.png' alt='' />
                        </Link>
                        <h5 className='mb-12'>Sign In to your Account</h5>
                        <p className='mb-32 text-secondary-light text-lg'>
                            Welcome back! please enter your detail
                        </p>
                    </div>
                    <form method="POST" onSubmit={handleSubmit}>
                        <div className='icon-field mb-16'>
                            <span className='icon top-50 translate-middle-y'>
                                <Icon icon='mage:email' />
                            </span>
                            <input
                                type='email'
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className='form-control h-56-px bg-neutral-50 radius-12'
                                placeholder='Email'
                            />
                            {validationErrors.email && (
                                <small className="text-danger">{validationErrors.email[0]}</small>
                            )}
                        </div>
                        <div className='position-relative mb-20'>
                            <div className='icon-field'>
                                <span className='icon top-50 translate-middle-y'>
                                    <Icon icon='solar:lock-password-outline' />
                                </span>
                                <input
                                    type='password'
                                    className='form-control h-56-px bg-neutral-50 radius-12'
                                    id='your-password'
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder='Password'
                                />
                                {validationErrors.password && (
                                    <small className="text-danger d-block mt-1">{validationErrors.password[0]}</small>
                                )}
                            </div>
                            <span
                                className='toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
                                data-toggle='#your-password'
                            />

                        </div>
                        <div className=''>
                            <div className='d-flex justify-content-between gap-2'>
                                <div className='form-check style-check d-flex align-items-center'>
                                    <input
                                        className='form-check-input border border-neutral-300'
                                        type='checkbox'
                                        defaultValue=''
                                        id='remeber'
                                    />
                                    <label className='form-check-label' htmlFor='remeber'>
                                        Remember me{" "}
                                    </label>
                                </div>

                            </div>
                        </div>
                        <button
                            type='submit'
                            className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
                        >
                            {" "}
                            Sign In
                        </button>

                    </form>
                </div>
            </div>
        </section>
    );
};

export default SignInLayer;
